import { NgxSpinnerService } from 'ngx-spinner';

import { PreloaderService } from './../_services/Preloader.service';
import { HttpErrorResponse } from '@angular/common/http';
import { User } from './../_models/User';
import { _userServicesService } from './../_services/_UserService/_userServices.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Device } from '../_models/Device';
import { ToasterService } from './../_services/Toaster.service';
import { DeviceService } from '../_services/_DeviceService/Device.service';
import { Observable, interval } from 'rxjs';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-User_Manage',
  templateUrl: './User_Manage.component.html',
  styleUrls: ['./User_Manage.component.css']
})
export class User_ManageComponent implements OnInit, AfterViewInit {

  Mode=false;
  AddUserMode = false;
  EditUserMode = false;
  selectedDevice: string;
  Device: Device[];
  ResponseDevice: Device[];
  Users: User[];
  User:User;
  dataTable = false;
  Response: any;
  updateSubscription: any;
  EditModel:User;
  dropdownList = [];
  selectedItems = [];
  // dropdownSettings = {};
  dropdownSettings:IDropdownSettings;
  constructor(private Spinner:NgxSpinnerService, private DeviceService: DeviceService, private preloader: PreloaderService, private UserService: _userServicesService, private noti: ToasterService) { }

  ngOnInit() {


 this.LoadAllDevices();


 this.dropdownList =[];

//  [
//   { item_id: 1, item_text: 'Mumbai' },
//   { item_id: 2, item_text: 'Bangaluru' },
//   { item_id: 3, item_text: 'Pune' },
//   { item_id: 4, item_text: 'Navsari' },
//   { item_id: 5, item_text: 'New Delhi' }
// ];




// this.selectedItems = [
//   { item_id: 3, item_text: 'Pune' },
//   { item_id: 4, item_text: 'Navsari' }
// ];

this.dropdownSettings= {
  singleSelection: false,
  idField: 'item_id',
  textField: 'item_text',
  selectAllText: 'Select All',
  unSelectAllText: 'UnSelect All',
  itemsShowLimit: 3,
  allowSearchFilter: true
};

  }

  ngAfterViewInit() {
    //this.preloader.hide();
  }
  AddUserToggle() {
    if (this.selectedDevice != undefined) {
      this.Mode=true;
      this.AddUserMode = true;
    }
    else {
      this.noti.info("Select Device First", "Error")
    }
  }

  EditUserToggle(Model:User) {
    if (this.selectedDevice != undefined) {
      this.EditUserMode = true;
      this.Mode=true;
      this.User=Model;
    }
    else {
      this.noti.info("Select Device First", "Error")
    }
  }

  selectChangeHandler(event: any) {
    this.selectedDevice = event.target.value;
    this.LoadAllUser(this.selectedDevice);
  }

  LoadAllDevices() {
    // tslint:disable-next-line: no-shadowed-variable
    try {
      this.DeviceService.GetActiveDeviceList().subscribe(
        Response => {

          if (Response.status == 200) {
           this.Device=Response.body;
            this.preloader.hide();
            this.Device.forEach(item=>{
              this.dropdownList.push(
              {
                item_id:item.device_id,
                item_text:item.deviceName
              });
            });

          }
          else {
            this.noti.error("Error", Response.body);
            this.preloader.hide();
          }

        },
        err => {
          this.noti.error("Error", err.error);
          this.preloader.hide();
        }
      );

    } catch (error) {
      this.noti.error("Error", "Code Crashed");
      this.preloader.hide();
    }
  }

  LoadAllUser(Devid: any) {
    this.Mode=true;
    this.Spinner.show();
    // tslint:disable-next-line: no-shadowed-variable
    this.UserService.GetUserList(Devid).subscribe(
      Response => {
        if (Response.status == 200) {
          this.Users = Response.body;
          this.dataTable = true;

        }
        this.Spinner.hide();
        this.Mode=false;

      }, error => {
        this.noti.error('Something Went Wrong', error);
        this.Spinner.hide();
        this.Mode=false;
      });

  }

  CancelAddUserMode(AddUserMode: any) {
    this.AddUserMode = AddUserMode;
    this.Mode=false;
    this.LoadAllUser(this.selectedDevice);
  }

  CancelEditUserMode(EditUserMode: any) {
    this.EditUserMode = EditUserMode;
    this.Mode=false;
    this.LoadAllUser(this.selectedDevice);
  }

  DeleteUser(UserID: any) {
    this.Spinner.show();
    // tslint:disable-next-line: no-shadowed-variable
    if (this.selectedDevice == '') {
      return this.noti.error("Error", "No Device Selected")
    }

    this.UserService.DeleteUser(UserID, this.selectedDevice).subscribe(
      Response => {

        if (Response.status == 200) {
          this.noti.success("Success", "Successfully Deleted")
          this.LoadAllUser(this.selectedDevice);
          this.Spinner.hide();
        }
        else {
          this.noti.error("Error", Response.body)
          this.Spinner.hide();
        }

      },
      err => {
        this.noti.error("Error", err.error)
        this.Spinner.hide();
      }
    );
  }

  DeleteUserFromDB(UserID: any) {
    this.Spinner.show();
    // tslint:disable-next-line: no-shadowed-variable
    if (this.selectedDevice == '') {
      return this.noti.error("Error", "No Device Selected")
    }

    this.UserService.DeleteUserFromDB(UserID, this.selectedDevice).subscribe(

      Response => {
        console.log(Response)
        if (Response.status == 200) {
          this.noti.success("Success", "Successfully Deleted")
          this.LoadAllUser(this.selectedDevice);
          this.Spinner.hide();
        }
        else {
          //this.noti.error("Error", Response.body)
          this.Spinner.hide();
        }

      },
      err => {
        this.Spinner.hide();
        if(err.error=='404')
        {
          this.noti.error("Error", "User Not Found")
        }
        else
        {
        this.noti.error("Error", err.error)
        }

      }
    );
  }


}
